var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTawsel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.2,
    y: 61.3,
    width: 97.9,
    height: 214.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,281.31H80.2V55.3H190.1Zm-97.9-12h85.9V67.3H92.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2,
    y: 164.93,
    width: 97.9,
    height: 6.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2,
    y: 119.75,
    width: 97.9,
    height: 6.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.18,
    y: 117,
    width: 93.94,
    height: 5.5,
    transform: "translate(38.4 277.9) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.18,
    y: 117,
    width: 93.94,
    height: 5.5,
    transform: "translate(15.4 254.9) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.18,
    y: 117,
    width: 93.94,
    height: 5.5,
    transform: "translate(-7.6 231.9) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.06,
    y: 54.31,
    width: 120.18,
    height: 21.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.06,
    y: 54.31,
    width: 120.18,
    height: 15.3,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.49,
    y: 43.33,
    width: 135.31,
    height: 21.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.16,
    y: 61.3,
    width: 97.9,
    height: 214.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.07,281.31H266.17V55.3h109.9Zm-97.9-12h85.9V67.3h-85.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.16,
    y: 164.93,
    width: 97.9,
    height: 6.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.16,
    y: 119.75,
    width: 97.9,
    height: 6.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.15,
    y: 117,
    width: 93.94,
    height: 5.5,
    transform: "translate(224.37 463.86) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.15,
    y: 117,
    width: 93.94,
    height: 5.5,
    transform: "translate(201.37 440.86) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.15,
    y: 117,
    width: 93.94,
    height: 5.5,
    transform: "translate(178.37 417.86) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.03,
    y: 54.31,
    width: 120.18,
    height: 21.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.03,
    y: 54.31,
    width: 120.18,
    height: 15.3,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.46,
    y: 43.33,
    width: 135.31,
    height: 21.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.79,347.7l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45-.06-11.19.5.5L428,337c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.14,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5l0,11.19v.45h-.45c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,361.81l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45-.05-11.19.49.5-13.24-.06c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.51v.5l-.05,11.19v.45H456c-2.23,0-4.46,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,361.81l13.36-.28,6.58-.11c2.18-.05,4.36,0,6.54-.06l-.44.45L426,350.62l.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.54Zm0,0-.14-5.54c-.05-1.86-.11-3.75-.13-5.65v-.27H400c4.41-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5L427,361.81v.45h-.44c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,361.81l13.35-.28,6.58-.11c2.19-.05,4.37,0,6.55-.06l-.45.45-.05-11.19.5.5L72,351.06c-4.42,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.15-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.28c4.41-.05,8.82-.16,13.24-.17l13.24-.06h.5v.5l-.06,11.19v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,59.86l13.35-.28,6.58-.12c2.19,0,4.37,0,6.55-.05l-.45.44-.05-11.18.5.49L72,49.1c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.87-.11-3.76-.13-5.65V48.4h.28c4.41,0,8.82-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.18v.45h-.44c-2.23,0-4.47,0-6.7,0l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,74l13.35-.27,6.58-.12c2.19,0,4.36,0,6.55,0L70,74l0-11.18.5.49L57.2,63.21c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.53c0-1.87-.11-3.76-.13-5.65v-.27H44c4.41,0,8.82-.16,13.24-.16l13.24-.06h.5v.51L70.88,74v.45h-.44c-2.24,0-4.47,0-6.7,0l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,59.87l13.36-.28,6.58-.11c2.19,0,4.36,0,6.54-.06l-.44.45-.05-11.19.49.5-13.24-.07c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.14-5.54c0-1.87-.11-3.75-.13-5.65v-.27h.27c4.42,0,8.83-.15,13.24-.16L456,48.18h.51v.5l-.05,11.19v.45H456c-2.23,0-4.46,0-6.69-.05l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.8,181.82l-13.36.28-6.58.11c-2.19,0-4.36,0-6.55,0l.45-.44.05,11.19-.5-.5,13.25.06c4.41,0,8.82.11,13.24.16l-.28.28c0-1.83.09-3.68.13-5.54Zm0,0,.14,5.53c0,1.87.11,3.76.13,5.66v.27h-.27c-4.42.05-8.83.16-13.24.16l-13.25.07h-.5V193l.05-11.19v-.45h.44c2.24,0,4.47,0,6.7.06l6.66.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,167.71l-13.35.28-6.58.11c-2.19.05-4.37,0-6.55.05l.45-.44,0,11.19-.5-.5,13.24.06c4.42,0,8.83.11,13.24.16l-.27.28c0-1.83.09-3.68.13-5.54Zm0,0,.15,5.53c0,1.87.11,3.76.13,5.66v.27H242c-4.41.05-8.82.16-13.24.16l-13.24.07H215v-.5l.06-11.19v-.45h.44c2.23,0,4.47,0,6.7.06l6.66.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.29,
    cy: 458.6,
    rx: 238.65,
    ry: 23.78,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "54.73 432.79 134.79 432.55 214.86 432.46 375 432.3 535.14 432.46 615.21 432.55 695.27 432.79 615.21 433.04 535.14 433.13 375 433.29 214.86 433.13 134.79 433.04 54.73 432.79",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "461.3 186.88 438.86 66.37 418.12 186.87 417.13 186.7 438.82 60.7 462.28 186.69 461.3 186.88",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.3 286.45 439.1 226.97 424.12 286.44 423.15 286.2 439.06 223.03 456.26 286.19 455.3 286.45",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.9,62.58a2.06,2.06,0,1,1-2.06-2.06A2.05,2.05,0,0,1,440.9,62.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.89 284.43 457.26 292.79 455.75 312.7 423.67 312.7 422.16 292.79 421.52 284.43 457.89 284.43",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.89 284.43 457.26 292.79 422.16 292.79 421.52 284.43 457.89 284.43",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.32,
    y: 281.75,
    width: 40.77,
    height: 6.49,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,280.41A2,2,0,0,1,459,282.2a2.07,2.07,0,0,1-2.33.68,2.38,2.38,0,0,1-2.34,1.38,2.39,2.39,0,0,1-1.39,2.89,1.48,1.48,0,0,1-1.53,1.05,2.44,2.44,0,0,1-1.8-1.26,1.86,1.86,0,0,1-2.74.25,1.51,1.51,0,0,1-.33-1.66,1.56,1.56,0,0,1-.36-.23,2.35,2.35,0,0,1-.64-2,2.22,2.22,0,0,1-1.66,0,1.29,1.29,0,0,1-1.16,1,2.25,2.25,0,0,1-.38,2,2.39,2.39,0,0,1-2.09.79c.23,1.1.28,2.34-.71,3.07a1.6,1.6,0,0,1-1.64.16,2.08,2.08,0,0,1-2.57,1.62,2.69,2.69,0,0,1-.25,2,1.81,1.81,0,0,1-1.37.89c0,1.07-.46,2.23-1.71,2.21a1.26,1.26,0,0,1-1.19-1.52,1.59,1.59,0,0,1-.81-2.63,2.3,2.3,0,0,1,0-3.61,1.51,1.51,0,0,1,.06-2.21,2.05,2.05,0,0,1-.73-1.6,2.23,2.23,0,0,1,1.16-1.79,1,1,0,0,1-.56-.56.86.86,0,0,1,0-.17,1.47,1.47,0,0,1-1.18,0,1.29,1.29,0,0,1-.59-.54,2.44,2.44,0,0,1-2.34.58,2,2,0,0,1-3,.61c-.73.66-1.74,1.3-2.7.7a1.2,1.2,0,0,1-.54-1.08,1.35,1.35,0,0,1-1.22-.72,1.27,1.27,0,0,1,.34-1.55,1.19,1.19,0,0,1-.46-.69,1.41,1.41,0,0,1,1.37-1.57,2,2,0,0,1,.38-2,2.83,2.83,0,0,1,2.29-.82,2.48,2.48,0,0,1,1.22-2.57,2,2,0,0,1,2.48.6,3.23,3.23,0,0,1,5.12-.33,1.6,1.6,0,0,1,2-.81,2.62,2.62,0,0,1,1.51,2.62,3.13,3.13,0,0,1,3.19.25,3.19,3.19,0,0,1,1.23,2.65,2.84,2.84,0,0,1,3,.18,6.22,6.22,0,0,1,3.18-2.43,3,3,0,0,1,2.6.55,3.56,3.56,0,0,1,6.48-.82,2.51,2.51,0,0,1,2.64-.34,4.74,4.74,0,0,1,2.32,3A1.93,1.93,0,0,1,461.2,280.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.01 187.22 463.16 198.4 461.14 225 418.28 225 416.26 198.4 415.4 187.22 464.01 187.22",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.01 187.22 463.16 198.4 416.26 198.4 415.4 187.22 464.01 187.22",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.47,
    y: 183.64,
    width: 54.49,
    height: 8.68,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,185.83a3.17,3.17,0,0,1,.66,3,5.78,5.78,0,0,1-3.33,3,3.56,3.56,0,0,1-1.19,5.23c1.3,1.52,1.83,3.25.15,4.37a3.91,3.91,0,0,1-1.18,5.56c.37,1.2-.79,4.79-3.25,4.79a2.6,2.6,0,0,1-2.26-3.85,3,3,0,0,1-.7-4.81s-1.52.32-2.25-.45a2.08,2.08,0,0,1-.12-2.05,3.48,3.48,0,0,1,.79-5.08,2.87,2.87,0,0,1,0-4.3,4,4,0,0,1-1.69-1.45c-1.25.6-2,.07-2.68-1.1a2.9,2.9,0,0,1-3.11.82,3.42,3.42,0,0,1-5,2,4.76,4.76,0,0,1-.94,2.55,8.37,8.37,0,0,1-.57.62,4.81,4.81,0,0,0-.55.9,4,4,0,0,1-1.13,1.3,2.12,2.12,0,0,1-2.83-.12,1.64,1.64,0,0,1-.26-1.68,2.18,2.18,0,0,1-1.36-2.76,2.65,2.65,0,0,1-2.61-1.51,2.8,2.8,0,0,1-2.14,1.07,3.15,3.15,0,0,1-1.79,4,3.24,3.24,0,0,1-1.39,4.61,2.27,2.27,0,0,1-.66,3,3,3,0,0,1-.11,2.61,1.9,1.9,0,0,1-1.77.84,1.39,1.39,0,0,1-.84-2.08,3.51,3.51,0,0,1-1.27-5.78,2.86,2.86,0,0,1-1.68-4.36,3,3,0,0,1-2.25-2.28,2.9,2.9,0,0,1,.62-2.31,1.71,1.71,0,0,1-1.56-.58,1.54,1.54,0,0,1-.32-1,2.21,2.21,0,0,1-2.39-1,2.16,2.16,0,0,1,.44-2.52,1.84,1.84,0,0,1-1.23-1.32,1.74,1.74,0,0,1,.14-1.11,2.13,2.13,0,0,1-2.55-1.79,1.73,1.73,0,0,1,1.16-1.81,2.18,2.18,0,0,1-.16-1.39c.32-1.32,1.85-1.73,3.06-1.88a2.72,2.72,0,0,1,3-3.56,2.81,2.81,0,0,1,1.3-2.61,2.65,2.65,0,0,1,2.94.23h.08a3.31,3.31,0,0,1,2.8,3.21,3.41,3.41,0,0,1,3.24,0,4.79,4.79,0,0,1,2.24,3.3,3.86,3.86,0,0,1,6.2.8,3.54,3.54,0,0,1,6.11,2,8.78,8.78,0,0,1,8.24-1.62,3.87,3.87,0,0,1,5.84-1.85,3.87,3.87,0,0,1,4-2.36,5.81,5.81,0,0,1,4.37,3.62,3.93,3.93,0,0,1,3.45,5.17A2.86,2.86,0,0,1,465.71,185.83Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.57,
    y: 58.45,
    width: 161.7,
    height: 374.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.57,
    y: 392.01,
    width: 161.7,
    height: 40.78,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.57,
    y: 58.45,
    width: 8.47,
    height: 374.34,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.07 413.38 510.04 432.79 510.04 58.45 602.07 85.81 602.07 413.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.69,319.61c.1,3.53.16,7.07.23,10.61s.12,7.08.16,10.61q.15,10.62.2,21.23c.05,7.08,0,14.16.05,21.24s0,14.17-.07,21.26l-.55-.88q5.52-.85,11-1.6l5.53-.69c1.84-.23,3.68-.45,5.52-.62-1.84.47-3.68.89-5.52,1.32l-5.53,1.25q-5.52,1.21-11,2.29l-.55.11v-1c0-7.08-.06-14.17-.08-21.26s0-14.19.06-21.29.09-14.2.18-21.3q.06-5.32.17-10.65C522.54,326.7,522.6,323.16,522.69,319.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.5,392c-.1-3.91-.16-7.83-.22-11.75s-.13-7.83-.17-11.76q-.14-11.76-.2-23.54c-.06-7.86,0-15.71-.08-23.57s0-15.72.06-23.58l.57.94q-6.87.13-13.73.11-3.42,0-6.86-.08c-2.28,0-4.57-.07-6.86-.16,2.29-.23,4.58-.41,6.86-.58s4.58-.35,6.86-.48q6.87-.44,13.73-.72l.56,0v1c.06,7.84.06,15.69.08,23.53s0,15.69-.05,23.54-.09,15.7-.18,23.55q-.06,5.89-.16,11.8C550.65,384.13,550.59,388.07,550.5,392Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.5,317.33c.1,3.34.16,6.69.23,10s.13,6.7.17,10.05q.15,10,.2,20.09c.06,6.69,0,13.39.07,20.09s0,13.41-.06,20.12l-.56-.82c3.69-.58,7.37-1.13,11.06-1.62l5.52-.71c1.84-.23,3.69-.46,5.53-.64-1.84.47-3.68.89-5.53,1.3l-5.52,1.24q-5.54,1.2-11.06,2.27l-.55.11v-.93q-.09-10.07-.09-20.13c0-6.72,0-13.43,0-20.15s.09-13.44.18-20.16q.06-5,.16-10.08C561.35,324,561.41,320.69,561.5,317.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.34,385.6c-.1-3.69-.16-7.39-.22-11.09s-.14-7.39-.18-11.1q-.15-11.1-.21-22.23c-.06-7.42-.06-14.84-.09-22.26s0-14.84.05-22.26l.56.88q-6.86.13-13.72.12c-2.28,0-4.57,0-6.86-.06s-4.57-.06-6.86-.14c2.29-.22,4.58-.39,6.86-.56s4.58-.34,6.86-.47c4.58-.27,9.15-.51,13.72-.69l.56,0v.91c.06,7.41.06,14.82.09,22.22s0,14.81,0,22.23-.09,14.82-.17,22.24c0,3.71-.09,7.43-.15,11.14S589.43,381.88,589.34,385.6Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.67,151c.1,3.56.16,7.11.22,10.66s.13,7.11.17,10.66q.13,10.63.19,21.27c0,7.09,0,14.17.06,21.25s0,14.16-.07,21.24l-.56-1c3.68.29,7.36.6,11,1l5.51.59c1.84.21,3.68.41,5.52.67-1.84,0-3.68,0-5.52,0l-5.51,0c-3.68,0-7.36-.15-11-.28l-.54,0v-1q-.07-10.65-.08-21.29c0-7.09,0-14.19.05-21.27s.1-14.18.19-21.26c0-3.54.09-7.07.16-10.61S522.57,154.54,522.67,151Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.42,229.87c-.09-3.93-.15-7.86-.22-11.79s-.13-7.87-.17-11.8q-.13-11.81-.2-23.59c-.05-7.87-.05-15.72-.07-23.58s0-15.72,0-23.56l.57,1.07c-4.57-1-9.13-2-13.7-3.09-2.28-.53-4.56-1.1-6.84-1.68s-4.57-1.13-6.85-1.76c2.28.3,4.56.67,6.85,1s4.56.72,6.84,1.12q6.86,1.17,13.7,2.47l.56.11v1c.06,7.85.06,15.69.08,23.54s0,15.69,0,23.52-.09,15.68-.18,23.52c0,3.92-.09,7.83-.16,11.75S550.51,226,550.42,229.87Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.4,157.76c.1,3.37.16,6.73.23,10.09s.13,6.73.17,10.09q.15,10.06.2,20.13c.06,6.71.06,13.41.07,20.11s0,13.4-.06,20.1l-.56-.95c3.68.28,7.36.59,11,.95l5.51.58c1.84.2,3.68.39,5.52.64-1.84,0-3.68,0-5.52,0l-5.51-.05c-3.68-.05-7.36-.16-11-.3l-.54,0v-.93c-.06-6.72-.07-13.43-.09-20.15s0-13.42,0-20.13.09-13.42.18-20.12q.06-5,.16-10C561.25,164.44,561.31,161.09,561.4,157.76Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.19,232.5c-.1-3.72-.16-7.43-.23-11.14s-.13-7.43-.17-11.14q-.15-11.15-.21-22.28c-.06-7.43-.06-14.85-.09-22.27s0-14.84,0-22.25l.56,1q-6.84-1.47-13.69-3.08c-2.28-.52-4.57-1.08-6.85-1.65s-4.56-1.13-6.85-1.74c2.29.31,4.57.67,6.85,1s4.56.72,6.85,1.12q6.84,1.19,13.69,2.5l.56.11v.91c.06,7.42.06,14.82.08,22.23s0,14.81,0,22.21-.08,14.8-.16,22.2q-.06,5.55-.16,11.1C589.34,225.09,589.28,228.8,589.19,232.5Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.66,88.79c.19,3.73.31,7.43.4,11.13s.15,7.39.19,11.08l-.59-1.17c1.84.37,3.68.78,5.51,1.2s3.67.89,5.51,1.4,3.67,1,5.51,1.6,3.67,1.18,5.51,1.9c-1.84-.13-3.67-.36-5.51-.64s-3.67-.58-5.51-.93-3.67-.74-5.51-1.14-3.67-.85-5.51-1.33l-.59-.15v-1c0-3.68.09-7.34.18-11S522.47,92.42,522.66,88.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.37,115.22c-.1-2.06-.16-4.12-.22-6.17s-.13-4.11-.17-6.15q-.15-6.15-.2-12.29l.58,1.13c-2.28-.52-4.57-1.15-6.85-1.73s-4.56-1.24-6.84-1.94-4.56-1.39-6.84-2.15c-1.14-.37-2.29-.78-3.43-1.2s-2.28-.82-3.42-1.29c1.14.15,2.28.35,3.42.55s2.29.39,3.43.63c2.28.46,4.56,1,6.84,1.52s4.56,1.14,6.84,1.73,4.56,1.24,6.85,1.94l.58.17v1q0,6.09-.18,12.17-.06,3-.16,6.07C550.52,111.18,550.46,113.2,550.37,115.22Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.37,98.87c.19,3.53.31,7,.4,10.54s.16,7,.2,10.49l-.59-1.12c1.84.38,3.67.78,5.51,1.21s3.67.89,5.51,1.39,3.67,1,5.5,1.58,3.68,1.17,5.51,1.87c-1.83-.15-3.67-.39-5.5-.67s-3.68-.6-5.51-1-3.67-.75-5.51-1.15-3.67-.85-5.51-1.32l-.6-.15v-1c0-3.48.09-6.95.18-10.41S561.18,102.3,561.37,98.87Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.08,124.23c-.1-2-.16-3.89-.22-5.83s-.13-3.88-.18-5.81c-.09-3.88-.16-7.74-.19-11.6l.57,1.07c-2.28-.53-4.56-1.15-6.84-1.74s-4.57-1.24-6.85-1.93-4.56-1.38-6.84-2.13c-1.14-.37-2.28-.78-3.42-1.19s-2.28-.81-3.42-1.27c1.14.16,2.28.37,3.42.57s2.28.41,3.42.65c2.28.47,4.56,1,6.84,1.53s4.56,1.15,6.85,1.74,4.56,1.24,6.84,1.93l.58.18v.9q0,5.74-.17,11.48c0,1.91-.09,3.82-.16,5.73S589.18,122.33,589.08,124.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "577.56 250.37 577.59 285.87 589.2 285.72 589.17 250.83 577.56 250.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.33 258.23 580.33 266.25 589.18 265.25 589.17 258.48 580.33 258.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.33 254.22 580.33 262.24 595.72 262.58 595.71 254.75 580.33 254.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "677.73 43.33 677.73 432.79 663.27 432.79 663.27 58.45 501.56 58.45 501.56 432.79 487.12 432.79 487.12 43.33 677.73 43.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.62,425.76c2,.58,60.93-2.51,63-4,.26-.17.1-5.49-.25-12.79l1.25-43.48L611.38,367l-1.55,37.68s-8.22,4.17-15,7.8l0,0a80.54,80.54,0,0,0-8.61,5C584.07,419.34,582.59,425.19,584.62,425.76Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.62,425.76c2,.58,60.93-2.51,63-4,.26-.17.1-5.49-.25-12.79-14.44,3.78-53,10.49-54.31,7.47-.49-1.19.38-2.62,1.72-3.95a80.54,80.54,0,0,0-8.61,5C584.07,419.34,582.59,425.19,584.62,425.76Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.52,207.08S649.16,319.54,649,320.91c0,.18,1.8,81.83,1.8,81.83l-41.3,1.66S610.79,333,611.86,317c1.36-20.4,9-108.54,9-108.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.9,395.34c10.63-.85,35.27-1.12,36.68-1.12.36,0,.18.31.08.32-3.37.46-26.82,1.24-36.79,1.23C611.76,395.77,611.79,395.34,611.9,395.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649,320.9s0,.33,0,.92L628.83,208.18l29.69-1.1S649.16,319.53,649,320.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.27 365 663.17 364.67 663.27 364.63 663.27 365",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.44,414.58c-.06.15-.12.29-.17.44v14a34.78,34.78,0,0,1-4.14,1.7c-2.1.26-3-5.71-1.73-8.27a80.25,80.25,0,0,1,5.87-7.7Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.27,415c-.57,1.52-.73,2.91,0,3.76v10.28a34.78,34.78,0,0,1-4.14,1.7c-2.1.26-3-5.71-1.73-8.27a80.25,80.25,0,0,1,5.87-7.7l.17-.21C663.38,414.73,663.32,414.87,663.27,415Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.27,206.9V375.54c-5.06-18.22-11.4-41.83-14.24-55.43-.6-2.89-1-5.32-1.28-7.16-2.25-17.16-5.11-52.3-6.75-77.82v0s-4.88-3-8.38-5.52a21.52,21.52,0,0,1-3.08-2.54l-.08-.09c-1.53-1.81-3.24-8.09-6.07-14.74-.13-.3-.26-.61-.4-.92s-.25-.57-.39-.86-.39-.86-.6-1.28c-.1-.24-.22-.47-.33-.7l4.29-.16,2.87-.11,29.69-1.1,1.8-.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.39,226.54a39,39,0,0,1,7.23,4.15c2.4,1.59,4.59,3.44,6.9,5.15.09.06,0,.21-.09.15-2.43-1.51-5-2.83-7.36-4.38a46.72,46.72,0,0,1-6.79-4.88C628.2,226.65,628.29,226.5,628.39,226.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.88,211.66c.33,1.65.75,3.27,1.13,4.9s.61,3.1,1,4.62a7.87,7.87,0,0,0,2.2,3.84c.61.56,1.28,1,1.93,1.55.35.27.73.53,1.09.81,0-.22-.09-.44-.13-.66-.12-.63-.23-1.25-.34-1.88-.25-1.38-.49-2.77-.72-4.16-.46-2.72-.88-5.48-1.48-8.18a.09.09,0,0,1,.17,0c.71,2.67,1.5,5.31,2.13,8,.3,1.32,1.42,7.86,1.48,8.32s.1,1,.12,1.44a6,6,0,0,1,0,1.47.12.12,0,0,1-.22,0h0a5.85,5.85,0,0,1-.44-1.42c-.12-.47-.23-.94-.32-1.41,0-.18-.06-.35-.09-.53-.65-.38-1.26-.89-1.86-1.32s-1.33-.91-2-1.42a7.4,7.4,0,0,1-2.4-3.65,27.59,27.59,0,0,1-.83-4.69c-.23-1.86-.4-3.73-.69-5.58C627.7,211.6,627.86,211.55,627.88,211.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.29,155.66h0v11.73l-1.69-.16c-.1-.27-.21-.56-.32-.87l-.29-.86c-.13-.4-.26-.83-.39-1.28-.09-.28-.17-.56-.24-.86s-.23-.84-.33-1.28c-.07-.28-.14-.57-.2-.86s-.19-.84-.27-1.28c-.06-.28-.11-.57-.15-.86s-.15-.84-.21-1.28l-.12-.86c0-.42-.1-.84-.14-1.28,0-.28,0-.57-.07-.86s-.06-.85-.07-1.28,0-.57,0-.86v0c0,.08-.07.39-.16.86s-.14.78-.24,1.28c0,.27-.1.56-.15.86s-.14.83-.22,1.28c0,.27-.09.56-.14.86s-.14.84-.21,1.28l-.12.86c-.07.42-.13.85-.19,1.28l-.12.86-.15,1.28c0,.29-.07.58-.1.86,0,.44-.08.87-.11,1.28s-.05.58-.06.86c0,.12,0,.24,0,.36l-.55-.06-.56-.06-.54-.06-.24,0-1.41-.16h-.09c-.06-.28-.11-.56-.17-.85s-.14-.84-.21-1.28l-.12-.86c-.05-.41-.1-.84-.13-1.28,0-.28-.05-.57-.07-.86s0-.75,0-1.14a.65.65,0,0,1,0-.14.86.86,0,0,1,0-.16l0,.16c0,.22-.13.67-.25,1.28,0,.26-.09.54-.15.86s-.15.82-.23,1.28c0,.28-.09.56-.13.86s-.14.85-.21,1.28l-.09.63-5.59-.63-4.33-.5-1.17-.14-5.36-.64-7.16-.86-1.77-.21c.08-.36.15-.72.21-1.07s.1-.57.15-.86.12-.86.16-1.28.07-.58.09-.86c0-.44.07-.87.08-1.28,0-.2,0-.4,0-.59v-.27a.6.6,0,0,0,0-.19.09.09,0,0,0,0-.05v-.17c0-.4,0-.77,0-1.13-.1-3.51-.78-5.54-.77-4.92a23.09,23.09,0,0,1-1.26,8,18,18,0,0,1-2.11,4.21l-.46,0-6.31-.77c-1.36-.15,4.37-4,4.48-8.23s-2.36-8.7.21-14.76a31.85,31.85,0,0,1,2.51-4.77c1.7-2.67,3.31-4.58,4.45-8.08h0l0-.09a6.44,6.44,0,0,0,.22-1.27c.31-3,0-9,1.44-14.48.14-.57.31-1.13.49-1.68a17.65,17.65,0,0,1,1.09-2.58,11.73,11.73,0,0,1,7.43-6.25l.07,0A14.78,14.78,0,0,1,654,104.3c7.41,3.09,5.6,14,4.82,20a8.24,8.24,0,0,0,0,2c.27,2.63,1.8,4.65,3.56,6.88l0,.05.87,1.12v21.22S663.28,155.65,663.29,155.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.27,132.52v1.68l-.35-.37-.52-.55,0-.05a18.62,18.62,0,0,1-3.15-4.29,10.25,10.25,0,0,1-1-6,11.21,11.21,0,0,0,.59,3.38,10.21,10.21,0,0,0,1.06,2.24A20.44,20.44,0,0,0,663.27,132.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.84,106A30.8,30.8,0,0,0,628.5,113c-.55,2.42-1,4.87-1.37,7.3l-.62,3.64a18.07,18.07,0,0,1-.89,3.44,19.79,19.79,0,0,1-3.9,5.93,27.14,27.14,0,0,0-2.29,3,17.22,17.22,0,0,0-1.69,3.48,24.56,24.56,0,0,0-.9,3.72,15.91,15.91,0,0,0-.16,3.84c.1,1.28.34,2.51.52,3.7a19,19,0,0,1,.22,3.61,7.61,7.61,0,0,1-3.57,5.95,7.73,7.73,0,0,0,4.34-5.88,18.48,18.48,0,0,0,0-3.79c-.09-1.26-.28-2.47-.3-3.66a19.69,19.69,0,0,1,1.24-7,17.42,17.42,0,0,1,1.58-3.14,26.59,26.59,0,0,1,2.2-2.86,35.21,35.21,0,0,0,2.32-3,15,15,0,0,0,1.78-3.45,19.55,19.55,0,0,0,.85-3.74c.19-1.24.33-2.46.47-3.69.3-2.45.55-4.9.91-7.34A35.58,35.58,0,0,1,630.84,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.09,146.67c-2.39,13.6-6.75,35.81-15.22,46.6-4.64,5.93-14.22,14.14-26.75,16.87l0-29.27c.86-.46,10.45-4.11,13.91-7.29,2.89-2.66,7.67-14.06,19.63-28.8C641,138.19,645.26,140,644.09,146.67Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.36,165.9l18.93,8.81s3.87-15.09,5.27-25.92c1.45-11.26-4-12.07-11.92-1.57A169.08,169.08,0,0,0,620.36,165.9Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.85,169.86c-2.58-1.49-11-4.85-12.33-5.42-.73-.31-3.68-1.38-4.4-1.68-.09,0-.14.11,0,.15,1.37.58,2.7,1.31,4.07,1.9s9.77,4.33,12.66,5.16C639.87,170,639.91,169.89,639.85,169.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.29,155.66h0v56.75l-5.19,0c-9.78,0-20.71-.06-28.52-.14l-1.55,0h-.22c-1.66,0-3.14,0-4.4-.06l-2.86,0-1.58,0,.13-.87.12-.86.19-1.28.12-.86.19-1.28.12-.86.19-1.28.12-.86.19-1.28.13-.86.07-.51.11-.77.13-.86.18-1.28.13-.86.18-1.27.13-.87.18-1.27.13-.87.19-1.27.12-.87.19-1.27.12-.87.19-1.27.12-.87.19-1.27.13-.87.18-1.27.09-.62a0,0,0,0,0,0,0,.31.31,0,0,1-.05-.09s0-.08-.07-.13,0,0,0,0h0a.67.67,0,0,1-.06-.12l-.12-.21c-.12-.24-.28-.56-.46-.94l-.39-.87c-.16-.39-.33-.81-.5-1.27-.1-.28-.21-.57-.3-.87s-.27-.83-.39-1.27c-.08-.28-.15-.57-.22-.87s-.18-.84-.25-1.27c0-.23-.08-.47-.12-.71,0-.05,0-.11,0-.16,0-.42-.09-.84-.11-1.27s0-.57,0-.86,0-.86.07-1.28.07-.57.12-.86c0-.13,0-.27.07-.4a8.86,8.86,0,0,1,.23-.88c.08-.27.18-.56.29-.86s.14-.39.23-.59h0a7.08,7.08,0,0,1,.28-.65s0,0,0,0c.12-.28.25-.57.39-.86s.4-.84.62-1.28l.45-.86.24-.43s0-.09.07-.14l.4-.71c.15-.28.32-.57.49-.86s.49-.85.75-1.28l.52-.86.8-1.28c.07-.11.14-.23.22-.34s.22-.34.33-.52l.15-.24.67-1,.57-.86c.28-.43.57-.86.86-1.28l.58-.86.88-1.28.3-.43.18-.26.12-.17c.3-.44.6-.86.9-1.27l.62-.87.92-1.27.64-.87c.34-.45.65-.88.95-1.27l.66-.87c.38-.5.71-.92,1-1.27s.51-.64.67-.81l0,0,0,0,.1-.11.51-.49.13-.11a8.64,8.64,0,0,1,.67-.56c.26-.2.52-.4.79-.57a4.66,4.66,0,0,1,.47-.3A11.07,11.07,0,0,1,650,139a11.64,11.64,0,0,1,1.64.78,9.46,9.46,0,0,1,.91.54,5.25,5.25,0,0,1,.49.33,16,16,0,0,1,1.28,1h0l.3.27.11.1h0l.3.28c.17.16.34.32.5.49s.38.38.56.58l.61.69a1.47,1.47,0,0,1,.1.13l.58.72s0,0,0,0c.3.4.61.82.9,1.27q.3.42.57.87c.26.41.52.83.78,1.27.16.29.33.58.5.87l.68,1.27.43.86c.21.42.42.84.63,1.28.13.28.27.57.4.86s.39.84.58,1.28c.12.26.24.54.36.81h0S663.28,155.65,663.29,155.66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.2,210.43l-.12.86h44.19v-.86Zm.31-2.14-.12.86h43.88v-.86Zm.31-2.14-.12.86h43.57v-.86Zm.31-2.14-.12.86h43.26V204Zm.32-2.14-.13.86h42.95v-.86Zm.31-2.14-.13.86h42.64v-.86Zm.31-2.14-.13.86h42.33v-.86Zm.31-2.14-.13.87h42v-.87Zm.31-2.14-.13.87h41.71v-.87Zm.31-2.14-.12.87h41.39v-.87Zm.31-2.14-.12.87h41.08V189Zm.31-2.14-.12.87h40.77v-.87Zm.32-2.14-.13.87h40.46v-.87Zm.13-2.14h0s0,.09.07.13a.31.31,0,0,0,.05.09,0,0,0,0,1,0,0l-.09.62h40.15v-.87Zm12.59-2.14H622.28a8.31,8.31,0,0,0,.35.87h12.68Zm-13.62,0,.39.87h40.84v-.87Zm-.8-2.14c.09.3.2.59.3.87h41.73v-.87Zm-.61-2.14c.07.3.14.59.22.87h42.42v-.87Zm-.38-2.14a.13.13,0,0,0,0,.06q0,.4.12.81h42.89v-.87Zm36.84-1.27c-.1-.27-.19-.55-.3-.86H640c-.07.31-.14.6-.21.86Zm-37-.86c0,.29,0,.57,0,.86h43.13v-.86Zm37.39-1.28c-.1-.29-.2-.57-.29-.86h-1.13l.28.86Zm-37.2-.86c0,.29-.09.57-.12.86h43.08v-.86Zm.59-2.14c-.11.3-.21.59-.29.86h42.66v-.86Zm.91-2.14c-.14.29-.27.58-.39.86h41.85v-.86Zm1.07-2.14-.45.86h40.84v-.86Zm31.7,2.14H630.11l2.08.86h22.62l-.17-.62Zm-30.5-4.28c-.17.29-.34.58-.49.86h39.68v-.86Zm1.27-2.14-.52.86h38.44v-.86Zm27.92,2.14s0,0,0,0c.11.28.22.56.34.84h.06c-.08-.29-.15-.57-.22-.86Zm-26.57-4.28c-.11.18-.23.35-.33.52s-.15.23-.22.34h37.12v-.86Zm36.57-1.32h0c-.12-.27-.24-.55-.36-.81H628.09l-.57.86h35.77S663.28,155.63,663.27,155.62Zm-1.34-3h-32.4l-.58.86h33.38C662.2,153.23,662.06,152.94,661.93,152.66Zm-1.06-2.14H631l-.12.17-.18.26-.3.43H661.3Zm-31.25,2.14-.4.65-.14.21h13.79c.06-.29.11-.58.16-.86Zm30.07-4.28H632.53l-.62.87h28.28C660,149,659.85,148.67,659.69,148.38Zm-1.35-2.14H634.09l-.64.87h25.46Q658.64,146.66,658.34,146.24Zm-.91-1.29-.58-.72a1.47,1.47,0,0,0-.1-.13h-21L635,145h22.4S657.43,145,657.43,145Zm-2.35-2.61-.31-.28-.11-.1H637.41l0,0,0,0c-.16.17-.38.44-.67.81h18.89C655.42,142.66,655.25,142.5,655.08,142.34Zm-16.83,1.76a4.06,4.06,0,0,0,.35.87h12.57a6.93,6.93,0,0,1,.21-.87Zm14.33-3.74a9.46,9.46,0,0,0-.91-.54H640.08a4.66,4.66,0,0,0-.47.3c-.27.17-.53.37-.79.57h14.25A5.25,5.25,0,0,0,652.58,140.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.63,157.55c1.44-2.4,2.9-4.79,4.43-7.13,0,0,0,0,0,0q-1.72,2.43-3.38,4.94c.05-.11.09-.23.14-.33.31-.64.6-1.28.91-1.9a0,0,0,1,0-.05,0,17.08,17.08,0,0,0-1,1.88c-.17.36-.31.73-.47,1.1-1.57,2.42-3.09,4.88-4.47,7.4a19.18,19.18,0,0,0-2.2,12.57,18.64,18.64,0,0,0,1,3.51,23.59,23.59,0,0,0,1.74,3.25.08.08,0,0,0,.14-.08,18.86,18.86,0,0,1-2.09-6.07,20.72,20.72,0,0,1-.15-6.48C621.72,165.51,624.27,161.5,626.63,157.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.76,141c-.34.9-4.28,4.51-8.4,3.27-2-.59-1.76-5.48-1.76-5.48l-.05-.58-.74-8.06,10-4.72,1.43-.61s.06,2.22.1,5v.39c0,.16,0,.31,0,.45,0,.42,0,.84,0,1.26s0,.63,0,1,0,.66,0,1A52.91,52.91,0,0,1,649.76,141Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.32,129.85a16.24,16.24,0,0,1-10.77,8.4l-.74-8.06,10-4.72,1.43-.61S650.28,127.08,650.32,129.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.55,118.3c-1.13,14.18,7.24,16.45,10.29,16.69,2.78.22,12.25.61,14.84-13.37s-3.65-19-10-19.82S629.68,104.13,628.55,118.3Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.94,115.29c.33,0,.64-.12,1-.19a1.64,1.64,0,0,0,1-.39.51.51,0,0,0,0-.62,1.25,1.25,0,0,0-1.23-.3,1.8,1.8,0,0,0-1.16.64A.54.54,0,0,0,630.94,115.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.23,115.79c-.33-.05-.63-.14-1-.22a1.51,1.51,0,0,1-.93-.4.51.51,0,0,1,0-.62,1.27,1.27,0,0,1,1.24-.28,1.82,1.82,0,0,1,1.15.66A.54.54,0,0,1,640.23,115.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,119.36s.08,0,.07.09c-.06,1,0,2.08.9,2.43,0,0,0,.06,0,.05C637.9,121.75,637.8,120.26,638,119.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.91,118.38c1.56-.07,1.58,3.05.13,3.12S637.6,118.43,638.91,118.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.52,118.54c.28.17.55.48.88.51s.66-.29.91-.61c0,0,.05,0,.05,0,0,.6-.21,1.21-.85,1.31s-1-.45-1.16-1.05C639.32,118.63,639.41,118.47,639.52,118.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.78,118.85s-.07.05-.07.09c0,1-.07,2.08-.94,2.41a0,0,0,0,0,0,.06C632.84,121.24,633,119.76,632.78,118.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.9,117.85c-1.56-.09-1.63,3-.19,3.12S633.21,117.93,631.9,117.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.25,118c-.25.16-.51.46-.8.47s-.59-.33-.8-.66c0,0,0,0,0,0,0,.6.15,1.22.72,1.35s.92-.38,1.08-1C631.43,118.15,631.35,118,631.25,118Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.77,127c-.2.26-.38.6-.72.68a2.76,2.76,0,0,1-1.07-.09s-.06,0,0,0a1.29,1.29,0,0,0,1.29.34,1,1,0,0,0,.63-1C638.88,126.92,638.8,126.91,638.77,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.2,123.2s-.21,1.45-.21,2.13c0,.06.16.09.39.11,0,0,0,0,0,0a3.21,3.21,0,0,0,3.15-1.19c.05-.07,0-.14-.1-.1a4.82,4.82,0,0,1-3,.83c0-.19.44-2.46.33-2.47a6.39,6.39,0,0,0-1.55.34c.34-3,1.17-6,1.47-9,0-.11-.15-.14-.18,0a49.06,49.06,0,0,0-2,9.6C632.52,123.82,633.92,123.32,634.2,123.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.43,125.25A4.14,4.14,0,0,0,636,126.6a1.74,1.74,0,0,0,1.11.13c.81-.16.87-.9.76-1.54a4.53,4.53,0,0,0-.3-1A5.3,5.3,0,0,1,634.43,125.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,126.6a1.74,1.74,0,0,0,1.11.13c.81-.16.87-.9.76-1.54A1.9,1.9,0,0,0,636,126.6Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.27,120.6c-1.54-.09-5.54-4.33-5.66-11.75,0,0,.57,6.66,1.07,7.64s-2.24-2.39-2.42-8.37a24.31,24.31,0,0,1-6.14,3.18c-2.83.79-4.56.76-4.77.56s4-1.51,5.09-2.81c0,0-7.52,3.49-11,3.76-.4,0-.88-8.22,4.48-11.72s13.86.28,16.14,2.49c0,0,2.68.38,5.59,4.35S654.93,120.7,653.27,120.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.26,122.65s2.85-4.6,4.93-3.61.1,7.54-2.21,8.56a2.41,2.41,0,0,1-3.29-1.11Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.58,120.9s0,0,0,.07a6,6,0,0,0-2.92,4,1.33,1.33,0,0,1,2-.48s0,.1,0,.1a1.47,1.47,0,0,0-1.6.6,7.6,7.6,0,0,0-.7,1.36c-.07.15-.34.09-.29-.08v0C650.85,124.29,652.32,121.24,654.58,120.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651,127.37a1,1,0,1,0,1-1.09A1,1,0,0,0,651,127.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.29,155.66h0v31.53l-.11-.3-.45-1.27c-.11-.29-.21-.58-.31-.87l-.45-1.27-.31-.87-.45-1.27c-.1-.29-.2-.58-.31-.87s-.29-.85-.44-1.27-.2-.58-.31-.87-.29-.85-.44-1.27l-.3-.87-.27-.81,0-.08a.06.06,0,0,1,0,0l-.12-.34-.3-.87c-.15-.43-.29-.85-.43-1.27,0-.1-.07-.2-.1-.29a.88.88,0,0,1,0-.15c-.05-.14-.1-.28-.14-.42-.15-.43-.29-.86-.43-1.28s-.2-.57-.29-.86-.29-.86-.43-1.28-.19-.58-.28-.86-.22-.66-.32-1c0-.1-.07-.2-.1-.3-.09-.29-.19-.58-.28-.86-.14-.43-.28-.86-.41-1.28l-.27-.86c-.14-.43-.28-.86-.4-1.28s-.19-.58-.27-.86c-.14-.44-.27-.86-.39-1.28s-.18-.58-.26-.86c-.13-.44-.26-.86-.38-1.28s-.17-.58-.25-.86c-.13-.44-.25-.87-.36-1.28s-.16-.58-.24-.86-.19-.72-.28-1.07a1.6,1.6,0,0,1,0-.21c-.08-.3-.15-.58-.21-.86-.11-.44-.2-.87-.28-1.28s-.11-.58-.16-.86c-.08-.44-.14-.87-.19-1.27s-.07-.59-.09-.87c0-.45-.06-.87-.06-1.27s0-.6,0-.87a11.47,11.47,0,0,1,.14-1.27,5,5,0,0,1,.21-.87,3.69,3.69,0,0,1,.64-1.27A2.17,2.17,0,0,1,654,142a2.85,2.85,0,0,1,.74.1h0c1.36.32,3.05,1.5,5,3.59,1.16,1.28,2.35,2.66,3.54,4.14v5.83S663.28,155.65,663.29,155.66Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.29,155.66h0v17.72l-1.46.67-1.9.87-.8.36,0,0-1,.43s-.11-.28-.3-.81c-.09-.24-.19-.53-.31-.87s-.28-.79-.44-1.27c-.1-.27-.19-.55-.3-.86l-.42-1.28-.28-.86c-.12-.41-.26-.83-.4-1.28-.09-.28-.17-.56-.26-.86l-.34-1.1a1.21,1.21,0,0,0-.05-.18c-.08-.28-.17-.56-.26-.86s-.24-.84-.36-1.28c-.08-.28-.16-.57-.25-.86s-.23-.85-.35-1.28-.15-.57-.22-.86-.23-.85-.34-1.28c-.07-.28-.15-.57-.22-.86s-.21-.85-.32-1.28-.14-.57-.2-.86-.11-.43-.16-.65-.1-.42-.14-.63-.14-.57-.2-.86l-.12-.54c-.06-.25-.11-.5-.16-.74s-.12-.58-.17-.86c-.08-.44-.16-.87-.22-1.28s-.09-.58-.13-.86c-.05-.44-.1-.86-.14-1.27l-.06-.87c0-.45,0-.87,0-1.27s0-.6,0-.87a11.37,11.37,0,0,1,.15-1.27,6.93,6.93,0,0,1,.21-.87,4.25,4.25,0,0,1,.57-1.27,2.46,2.46,0,0,1,.92-.87,2.41,2.41,0,0,1,1.48-.27h0c1.65.18,3.85,1.65,6.46,4.52.8.89,1.62,1.83,2.45,2.81v6.6S663.28,155.65,663.29,155.66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,175.26a3.43,3.43,0,0,1-.83.24c-.12-.76-1.1-4-1.35-4.82-.5-1.72-1-3.42-1.53-5.14-1-3.43-2-6.87-3-10.29,0-.07-.12,0-.11,0,.44,2.43,1,4.83,1.61,7.21-.17-.41-.34-.83-.5-1.25-.32-.83-.62-1.66-1-2.48a.05.05,0,1,0-.1,0,16.78,16.78,0,0,0,.87,2.56c.27.64.58,1.27.88,1.9.22.83.44,1.66.67,2.49.47,1.73,1,3.45,1.5,5.15.26.82.53,1.63.8,2.44a15,15,0,0,0,1.14,2.53,6.24,6.24,0,0,0,1-.46C659.19,175.35,659.11,175.22,659,175.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.27,169.72v.57l-.76.35-.25.11c-.93.42-1.88.78-2.82,1.17-.44.18-.88.37-1.31.57h0c-.09,0-.17-.09-.08-.14l.05,0,.82-.42,2.48-1.28c.36-.18.66-.34.84-.42l.92-.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.11,141s.07,0,.06,0c-.28,1.8-.18,3.71,1.29,5s3.66.92,5.35.57a12.29,12.29,0,0,0,4.87-2.16c1.27-1,2.33-2.93,1.2-4.54,0-.08,0-.12.06-.06a3.09,3.09,0,0,1,.49,3.55,7.18,7.18,0,0,1-3.56,3,13.42,13.42,0,0,1-5,1.26,4.48,4.48,0,0,1-4.11-1.61A5.62,5.62,0,0,1,638.11,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.29,155.66h0v0S663.28,155.65,663.29,155.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.44,404.58c-.06.15-.12.29-.17.44v-.23Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.65,452.69c-2.29.74-67.28-.1-69.73-1.71-.95-.59-1.37-10.07-1.56-21.54,0-.12,0-.24,0-.36,0-2.36-.07-4.79-.08-7.26,0-.34,0-.68,0-1l3.16-33.71,43.47.43-4.29,33.4,0,1.33-.26,6.91,0,.71s24.73,11.45,27.24,13.5S217.93,452,215.65,452.69Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.65,452.69c-2.29.74-67.28-.1-69.73-1.71-.95-.59-1.37-10.07-1.56-21.54,0-.12,0-.24,0-.36,0-2.36-.07-4.79-.08-7.26,0-.34,0-.68,0-1l42.34.12,0,1.33-.26,6.91,0,.71s24.73,11.45,27.24,13.5S217.93,452,215.65,452.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.65,452.69c-1.17.38-18.83.34-36.09,0-3.47-.07-6.92-.15-10.21-.24-12.31-.34-22.48-.84-23.43-1.46s-1.36-9.8-1.55-21.06c0-.16,0-.32,0-.48s0-.25,0-.36h.05l41.89.07,0,.72s24.74,11.44,27.24,13.49S217.93,452,215.65,452.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,450.16c-10.95-.41-55.17-1-66-.61-.09,0-.09.07,0,.07,10.84.65,55.06.91,66,.72C215.17,450.34,215.17,450.17,214.94,450.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,429.34c-4.3-.86-9.59-.27-12.92,2.76-.13.12,0,.3.18.26a60.31,60.31,0,0,1,12.71-2.48A.27.27,0,0,0,191,429.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,431.26c-4.3-.87-9.58-.27-12.91,2.76-.13.11,0,.3.18.25A60.93,60.93,0,0,1,194,431.8.27.27,0,0,0,194,431.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.13,433.17c-4.3-.86-9.58-.27-12.91,2.76-.13.12,0,.3.18.26a60.29,60.29,0,0,1,12.71-2.47A.28.28,0,0,0,197.13,433.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,452.68c-3.47-.07-6.92-.15-10.21-.24-12.31-.34-22.48-.84-23.43-1.46s-1.36-9.8-1.55-21.06c0-.16,0-.32,0-.48s0-.25,0-.36h.05C150.14,433.1,170.36,446.56,179.56,452.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,429.3H142.08S151.5,320,151.14,318.07c-.47-2.45-17.94-70.85-21.29-83.78-5-19.38-9-34.43-9-34.43h39.67s4.62,14.65,10.45,33.72c9.5,31,22.18,73.65,23.44,84C196.47,334.34,188.89,429.3,188.89,429.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.07,421.32c-7.15-.15-5.09-.21-12.24-.28-3.5,0-26.5-.23-29.77.31a.07.07,0,0,0,0,.14c3.27.55,26.27.35,29.77.31,7.15-.07,5.09-.13,12.24-.27C187.2,421.52,187.2,421.32,187.07,421.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,311.38c-1.54-6.76-3.83-13.39-5.83-20q-6.08-20.23-12.24-40.46-3.07-10.11-6.17-20.22-1.58-5.1-3.16-10.19c-1-3.33-2.23-6.62-3.17-10-.38-1.37-.59-.62-.1,1.11,1,3.5,2,7,3,10.47q3,10.35,6.09,20.68,6.08,20.58,12.28,41.11,3.09,10.31,6.19,20.6a84.14,84.14,0,0,1,2.53,10A45.81,45.81,0,0,1,160,325.1c-.45,7.16-1.28,14.31-1.94,21.46s-1.33,14.32-2,21.48q-2,21.38-3.92,42.75c-.17,1.8-.32,3.61-.46,5.42-.05.6.87.56.93,0,1.54-14.09,2.72-28.23,4.05-42.34s2.63-28.09,3.94-42.13c.33-3.52.71-7.06.71-10.6A43.79,43.79,0,0,0,160.2,311.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.31,199.86c-2.42,18.81-5.79,82-6.54,111.59-4.48-17.92-16.89-66.47-19.66-77.16l-8.89-34.16a0,0,0,0,1,0,0,1.43,1.43,0,0,0,0-.18.28.28,0,0,1,0-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77,452.69c-2.28.74-67.27-.1-69.73-1.71-.94-.59-1.37-10.07-1.56-21.54v-.36c0-2.36-.08-4.79-.08-7.26,0-.34,0-.68,0-1l3.15-33.71,43.48.43-4.29,33.4,0,1.33-.26,6.91,0,.71s24.74,11.45,27.25,13.5S169.05,452,166.77,452.69Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77,452.69c-2.28.74-67.27-.1-69.73-1.71-.94-.59-1.37-10.07-1.56-21.54v-.36c0-2.36-.08-4.79-.08-7.26,0-.34,0-.68,0-1l42.34.12,0,1.33-.26,6.91,0,.71s24.74,11.45,27.25,13.5S169.05,452,166.77,452.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78,452.69c-1.18.38-18.84.34-36.1,0-3.47-.07-6.92-.15-10.21-.24C108.16,452.1,98,451.6,97.05,451s-1.36-9.8-1.55-21.06c0-.16,0-.32,0-.48s0-.25,0-.36h0l41.89.07,0,.72s24.73,11.44,27.24,13.49S169.05,452,166.78,452.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,450.16c-11-.41-55.17-1-66-.61-.09,0-.09.07,0,.07,10.85.65,55.07.91,66,.72C166.3,450.34,166.3,450.17,166.07,450.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,429.34c-4.3-.86-9.58-.27-12.91,2.76-.13.12,0,.3.18.26a60.31,60.31,0,0,1,12.71-2.48A.27.27,0,0,0,142.08,429.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.17,431.26c-4.3-.87-9.58-.27-12.92,2.76-.13.11,0,.3.18.25a61,61,0,0,1,12.72-2.47A.27.27,0,0,0,145.17,431.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.26,433.17c-4.3-.86-9.58-.27-12.92,2.76-.13.12,0,.3.18.26a60.42,60.42,0,0,1,12.71-2.47A.28.28,0,0,0,148.26,433.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,199.86s-.92,19-5.26,34c-.35,1.24-.73,2.47-1.14,3.64,0,0,.61-.48-6.3,3.75,0,0,2.67,75.48,2.78,80C149.75,338.1,137.5,430,137.5,430l-46.8.19S107.42,326,107.36,319.81c-.09-9.93-6-53.07-4.17-85.05a90.36,90.36,0,0,1,9.51-34.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,421.67c-7.15-.12-5.1-.19-12.25-.23-3.5,0-26.49-.12-29.76.44a.07.07,0,0,0,0,.14c3.27.53,26.26.23,29.76.18,7.15-.1,5.1-.15,12.25-.33A.1.1,0,0,0,136.16,421.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.75,202.69c-5.92,11.38-8.13,24.33-8.61,37-.52,13.79,1.13,27.54,2.58,41.23,1.53,14.39,2.85,28.81,1.75,43.28s-3.7,29.13-5.8,43.63-4.3,29-6.1,43.54c-.23,1.84-.46,3.68-.67,5.52,0,.1.13.14.14,0,2.57-14.33,4.68-28.74,6.87-43.13s4.64-28.67,6.12-43.09.86-28.73-.59-43.11c-1.39-13.85-3.22-27.69-3.27-41.63,0-13,1.27-26.23,5.86-38.45.61-1.62,1.27-3.24,2-4.84C116.08,202.46,115.87,202.45,115.75,202.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,236.38a86.47,86.47,0,0,0-13.38,7,.15.15,0,0,0,.14.27c4.51-2.19,9.12-4.3,13.51-6.74A.3.3,0,0,0,155.09,236.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35,220.28c-.31,1.66-.71,3.31-1.07,5s-.59,3.13-1,4.67a8,8,0,0,1-2.17,3.91c-.61.56-1.28,1.07-1.93,1.58-.35.28-.73.55-1.09.83,0-.22.08-.44.12-.67.12-.63.22-1.26.33-1.89.23-1.4.46-2.8.67-4.21.42-2.76.81-5.55,1.39-8.28,0-.11-.15-.15-.17,0-.69,2.71-1.45,5.38-2.05,8.12-.29,1.34-1.34,8-1.39,8.42s-.09,1-.1,1.45a5.24,5.24,0,0,0,0,1.48c0,.12.17.1.22,0h0a5.83,5.83,0,0,0,.42-1.44c.12-.47.23-.95.31-1.43,0-.17.06-.35.08-.53.65-.39,1.26-.92,1.87-1.36s1.32-.94,1.94-1.46a7.51,7.51,0,0,0,2.38-3.71,27.21,27.21,0,0,0,.78-4.75c.21-1.88.36-3.77.62-5.64C155.54,220.21,155.37,220.16,155.35,220.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21,146c.6,7.78,5.21,26.1,15.51,42.36,4,6.27,20,14.55,33.1,19.91a106.92,106.92,0,0,0,14.91,5.11h0a14.33,14.33,0,0,0,1.57.28c6.25.75,10.56-8.7,11.25-15.77,0-.19,0-.39,0-.58l0-.31c.16-2.89-.33-5.25-1.59-6.17a14.33,14.33,0,0,0-1.39-.86A127.71,127.71,0,0,0,214,184.72c-1.15-.48-2.36-1-3.58-1.46-11.51-4.63-24.72-9.6-26-10.8-2-1.85-14.39-16.19-21.53-28.55C157.65,134.9,151.21,133.07,152.21,146Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,208.27a106.92,106.92,0,0,0,14.91,5.11h0A87.49,87.49,0,0,0,235.06,216c4,0,15.5-1.19,15.74-4.26s-3.15-3-3.15-3,4.78-1.23,4.74-4.34c0-2.55-3.57-2.84-4.85-2.87a.2.2,0,0,0-.19,0h-.27s4.82-1.62,4.56-4.72c-.23-2.77-4.46-2.15-5.35-2l0,0c.74-.23,4.19-1.49,3-3.7-1.55-3-9.53.33-14,.09-.21,0-1.32-.14-2.91-.33-3.28-2.49-7.36-4.8-9.17-5.23a59.68,59.68,0,0,0-9.27-.85c-1.15-.48-2.36-1-3.58-1.46C207.89,186.05,200.48,195.43,200.82,208.27Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,188.62l-.94,13.45v.05l0,.3-.72,10.2a18.39,18.39,0,0,0,2.38.76h0A87.49,87.49,0,0,0,235.06,216c4,0,15.5-1.19,15.74-4.26s-3.15-3-3.15-3,4.78-1.23,4.74-4.34c0-2.55-3.57-2.84-4.85-2.87h-.46s4.82-1.62,4.56-4.72c-.23-2.77-4.46-2.15-5.35-2l-.12,0,.09,0c.74-.23,4.19-1.49,3-3.7-1.55-3-9.53.33-14,.09-.21,0-1.32-.14-2.91-.33l-6.77-.83Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,196.29a34.78,34.78,0,0,0,5.63,1.17,14.34,14.34,0,0,0,9.57-2.44c.16-.09.18-.2.13-.26l0,0a.27.27,0,0,0-.23,0,21.81,21.81,0,0,1-8.93,2,36.45,36.45,0,0,1-6.09-.68C230.89,196.08,230.83,196.26,231,196.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.22,203c6.36,1.19,10.12,1.6,16.17-1.2.19-.08.24-.25.15-.32a.2.2,0,0,0-.19,0h0c-6.3,1.95-9.54,2-16.06,1.36C231.16,202.82,231.13,203,231.22,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,208.82c-6.26,1.46-9.81,1.69-16.07.23a.12.12,0,0,0-.06.23c6.23,2.11,10.67,1.86,16.15-.26C247.52,208.87,247.51,208.73,247.12,208.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.72,201.86a6.42,6.42,0,0,0,1-.19l.27-.08h0c5.14-1.66,7-9.33,7-9.33a30.12,30.12,0,0,0,5.29.77c2.57.14,5.18-.07,6.71-1.08h0a3,3,0,0,0,1-1,2.59,2.59,0,0,0,.29-.71s0,0,0-.07c.24-1.42-2.68-3.09-6.18-4.43-3.85-1.47-8.41-2.54-10.27-2.44a61,61,0,0,0-9.13,1.79c-1.27.33-2.11.57-2.11.57S210.63,202.55,216.72,201.86Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,191.17c-3.4,2.9-8.6,1.31-12.57.69-.3-.05-.44.17-.43.41-1.16,3.68-3.87,8.54-7.76,9.75a.09.09,0,0,0,0,.18c4.35-.73,7.4-5.29,8.41-9.4,4.06.71,9.34,2.07,12.34-1.6A0,0,0,0,0,237.68,191.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,169.71l24.84-2.79s-15.39-22.78-21.8-28.2c-7.22-6.1-8.76-1.08-8.09,7.89S156.64,169.71,156.64,169.71Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.64,169.71l24.84-2.79s-15.39-22.78-21.8-28.2c-7.22-6.1-8.76-1.08-8.09,7.89S156.64,169.71,156.64,169.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,162.49c-3.21,0-12.85,1.26-14.45,1.46-.84.1-4.18.66-5,.76-.1,0-.07.17,0,.16,1.6-.18,3.23-.2,4.84-.37s11.46-1.13,14.61-1.88A.07.07,0,0,0,176.71,162.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,168.21l-13.31,1.49s-4.37-14.13-5-23.1c-.49-6.51.19-10.95,3.38-10.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65,218.19c.14.19,64.45,6.77,65.14,6.13,1-.9-5.16-76.2-11.26-86-1.3-2.1-11.73-5-16.36-1.74C127.3,147,104.15,217.49,104.65,218.19Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.63,
    y: 160.69,
    width: 12.27,
    height: 1.99,
    transform: "translate(16.64 -13.67) rotate(5.65)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09,173.09c-.33.46-8,14.76-8.32,16.38s-11,40.91-10.39,42.08,17.37,7.78,18.11,7.78,34-7.41,35.79-8.66,2.44-31.89,1.77-35-2.68-8.81-2.68-8.81l1.24-1.72s-3.42-14.44-4.07-13.94S196.81,172.08,196.09,173.09Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,239.34c-.73,0-17.47-6.62-18.1-7.79s10.12-40.45,10.39-42.07,8-15.92,8.32-16.39c1.43,3,2.6,16.2,2.78,17.91S195.81,235.81,195.48,239.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,186.83c-2.54.4-5.1.64-7.66.89s-5.13.46-7.69.63-5.13.33-7.7.46-5.14.2-7.71.29h0a.86.86,0,0,1-.62-.48,2.63,2.63,0,0,1-.24-.58,7.83,7.83,0,0,1-.28-1.16,16.61,16.61,0,0,1-.26-2.33c.15.77.31,1.53.52,2.27a7.76,7.76,0,0,0,.37,1.09c.13.32.4.7.52.69h0c2.56-.22,5.12-.49,7.68-.68s5.13-.37,7.7-.51,5.13-.28,7.7-.36S227.8,186.89,230.37,186.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.12 192.61 217.35 192.66 214.26 183.22 219.03 183.18 222.12 192.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.62,176.43c-.59,4.32-1.28,8.62-2,12.91s-1.49,8.58-2.24,12.87-1.6,8.55-2.46,12.82l-1.3,6.4c-.48,2.13-.91,4.26-1.41,6.38.28-2.16.63-4.31.94-6.46l1-6.45c.71-4.3,1.5-8.58,2.24-12.87s1.6-8.55,2.46-12.82S194.64,180.67,195.62,176.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.78,230.89c2.36-1.3,4.8-2.44,7.26-3.51l.3-.13.23.26c1.34,1.52,2.66,3.06,3.94,4.65s2.5,3.21,3.65,4.89c-1.5-1.39-2.92-2.85-4.29-4.34s-2.7-3-4-4.6l.53.13C183.9,229.23,181.37,230.14,178.78,230.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,144.28c-6,16.19-17.25,56.68-9,61.85,13.64,8.49,41.4,11.07,49.79,11,3.62,0,7.89-27.82,4.15-28.83-4.49-1.21-33.31-2.1-33.88-4.4-.32-1.31.64-14.5-1-29.06C144.24,137.93,138.11,138.74,136.06,144.28Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.68,190.37s9.17-6.1,15.36-9.81c3.45-2.07,9.68-5.09,12.91-5.45,4.83-.53,25.38.3,25.28,5.29-.08,4.51-17.65,1.55-17.65,1.55s18,1.42,16.89,6.84-20.51-.57-20.51-.57,18.45,1.87,16.43,7.28c-1.53,4.08-19.4-.34-19.4-.34s15.84,1.72,14.45,6c-1.53,4.72-18.29,1.67-18.29,1.67-5.36,10.25-11.86,13.55-17.13,14.29C175.77,217.27,168.68,190.37,168.68,190.37Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,181.06c2.12.09,4.27.17,6.37.45s4.2.63,6.27,1.1a35.7,35.7,0,0,1,7.87,2.61c-4.62-1.75-12.13-2.86-14.23-3.14s-4.19-.66-6.29-.94C198.33,181.14,198.34,181.06,198.39,181.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,188.64c2.7.23,5.39.36,8.08.72s5.19.91,7.84,1.45c.2,0,.11.13-.09.1-2.67-.43-5.17-.62-7.84-1s-5.33-.9-8-1.2C197.2,188.7,197.21,188.64,197.25,188.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,195a60,60,0,0,1,12.27,2c.2.05.08.16-.13.12-4.07-.76-7.25-1.38-12.14-2C195,195.1,195,195,195.1,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.52,176.21c-4,.92-17.81,9.58-19.33,10.93-1.1-.12-5.84-.4-6.37-.32a.1.1,0,0,0,0,.19c.5.19,5.21.87,6.32,1,.19,0,16.17-10,19.63-11.65C192.89,176.27,192.66,176.18,192.52,176.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,171.69l-24.32,5.77s6.79-26.64,11-33.91c4.74-8.18,7.89-4,10.28,4.69S148.87,171.69,148.87,171.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,171.69l-24.32,5.77s6.79-26.64,11-33.91c4.74-8.18,7.89-4,10.28,4.69S148.87,171.69,148.87,171.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,167.49c-3.19.32-12.65,2.62-14.21,3-.83.19-4.09,1.1-4.91,1.29-.11,0,0,.18.05.16,1.58-.36,3.19-.55,4.77-.89S144,168.7,147,167.62A.07.07,0,0,0,147,167.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,153.83c0-.11-.14-.14-.17,0-.83,2.18-1.61,4.39-2.35,6.61a20.45,20.45,0,0,1,.66-3.61s-.06-.07-.08,0a16.76,16.76,0,0,0-.76,4.17c-.51,1.54-1,3.1-1.48,4.65-1.22,4-2.49,7.92-3.48,11.95a.29.29,0,0,0,.36.34c.84-.23,1.66-.48,2.49-.77.08,0,.07-.17,0-.16-.72.08-1.42.19-2.13.31,1.28-3.79,2.36-7.65,3.53-11.48S130.45,157.84,131.5,153.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42,161c0-1.32.05-2.64,0-4,0,0,0,0-.05,0q-.07,1.45-.12,2.91c-.25-1.92-.53-3.84-.9-5.73,0,0-.06,0,0,0,.13,2.93.43,5.85.64,8.77s.45,5.73.71,8.6c-.54.22-1.07.42-1.62.62a.08.08,0,0,0,.05.16c.62-.11,1.24-.23,1.87-.32a.29.29,0,0,0,.27-.28C149.12,168.16,148.85,164.55,148.42,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,147c-2.28.12-8.48-4.65-10.54-9.34-.14-.33,2.21-12.5,2.42-15,0-.5,15.1,5.1,15.1,5.1a39.51,39.51,0,0,0-2.31,9.31,4.91,4.91,0,0,0,0,1,1,1,0,0,1,0,.17C158.49,140.2,157,146.79,153.65,147Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52,122.82c.25,3.78,1.72,14.44,10.23,15.38a9.68,9.68,0,0,0,1.59.05.91.91,0,0,0,0-.17,6.89,6.89,0,0,1,0-1,39.66,39.66,0,0,1,2.31-9.32S149.88,123.75,146.52,122.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,101.87c-2.81,5-3.35,21.13-.28,25.42,4.44,6.21,13.39,8.66,19.1,2.94,5.53-5.55,5.86-26.57,2.28-30.64C163,93.6,151.31,94.47,147.17,101.87Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,114.5s-.08,0-.08.1c0,1.08-.2,2.33-1.2,2.65a0,0,0,0,0,0,.06C159.9,117.19,160.14,115.53,160,114.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.05,113.33c-1.74-.2-2,3.3-.4,3.48S160.51,113.5,159.05,113.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.23,115.17s.08,0,.07.1c-.11,1.08-.07,2.34.88,2.77,0,0,0,.07,0,.06C166,117.84,165.94,116.17,166.23,115.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,114.11c1.75,0,1.62,3.51,0,3.5S165.81,114.11,167.28,114.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,111.63a13,13,0,0,0,1.39-.38,2.29,2.29,0,0,0,1.35-.65.74.74,0,0,0-.05-.9,1.85,1.85,0,0,0-1.83-.33,2.68,2.68,0,0,0-1.65,1A.8.8,0,0,0,157.79,111.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,112.45a12.79,12.79,0,0,1-1.36-.46,2.35,2.35,0,0,1-1.3-.75.74.74,0,0,1,.11-.89,1.85,1.85,0,0,1,1.86-.21,2.73,2.73,0,0,1,1.56,1.16A.79.79,0,0,1,168.77,112.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,124.48c.24.27.47.64.86.7a2.85,2.85,0,0,0,1.19-.18s.07,0,0,.06a1.46,1.46,0,0,1-1.42.48,1.17,1.17,0,0,1-.78-1C158.07,124.45,158.16,124.44,158.19,124.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,121.32a3.69,3.69,0,0,0,2.33,1.83,5,5,0,0,0,1.33.17h.25l.24,0a.28.28,0,0,0,.24-.23h0v-.12h0v-.1c.09-.83.11-2.1.11-2.1.29.17,1.79,1,1.8.55a55.34,55.34,0,0,0-.57-11.27c0-.12-.2-.1-.2,0-.2,3.48.22,7,.07,10.47a6.83,6.83,0,0,0-1.7-.66c-.12,0,0,2.46-.06,2.83a.1.1,0,0,1,0,0,5.11,5.11,0,0,1-3.72-1.48C159.61,121.16,159.52,121.23,159.58,121.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,122.86a4.4,4.4,0,0,1-1.86,1.22,2,2,0,0,1-1.2,0c-.85-.29-.81-1.09-.6-1.76a5.13,5.13,0,0,1,.47-1A5.72,5.72,0,0,0,162.78,122.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.92,124.08a2,2,0,0,1-1.2,0c-.85-.29-.81-1.09-.6-1.76A2,2,0,0,1,160.92,124.08Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,116.57c3-.37,5.88-9.66,5.88-9.66s-.65,4,.12,4,4.72-5,5.69-8.86a31,31,0,0,0,6.64,4.62c3.43,1.64,7.06,1.91,7,1.29,0-1.91-.34-6.66-1.55-8.11a13.73,13.73,0,0,0-13.35-4.23c-6.22,1.34-8.34,4.87-9.67,7.66S144.1,116.7,145.19,116.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61,103.77c-1.46-.59-9.94-1.6-14-.53s-11.59,5.52-12,5.75,0-13.94,11.62-14.8C169,93.26,170.61,103.77,170.61,103.77Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,108.52s8.93-8.73,13.41-10.36,14-1.52,19.32,1.87c4.19,2.64-7.6,6.77-7.6,6.77a3.17,3.17,0,0,0-1.42-2.43c-2.64-1.52-8.07-1.46-11.25-.89C153.85,104.19,145.39,108.52,145.39,108.52Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,108.52s8.93-8.73,13.41-10.36,14-1.52,19.32,1.87c4.19,2.64-7.6,6.77-7.6,6.77a3.17,3.17,0,0,0-1.42-2.43c-2.64-1.52-8.07-1.46-11.25-.89C153.85,104.19,145.39,108.52,145.39,108.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,120.85a4.87,4.87,0,1,1,6-4.84h0a4.87,4.87,0,0,1-4.78,5A4.75,4.75,0,0,1,157.06,120.85Zm2.07-8.86a4.07,4.07,0,0,0-1-.11,4.22,4.22,0,1,0,1,.11Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,122.05c-1.81-.42-3-2.67-2.74-5.19a5.78,5.78,0,0,1,1.41-3.28,3,3,0,0,1,5.17.59,5.9,5.9,0,0,1,.64,3.5c-.31,2.67-2.17,4.66-4.16,4.44A1.8,1.8,0,0,1,168.18,122.05Zm1.59-8.94a1,1,0,0,0-.25,0,2.58,2.58,0,0,0-2.19,1,5.22,5.22,0,0,0-1.24,2.91c-.26,2.31.84,4.35,2.48,4.53s3.17-1.55,3.44-3.86a5.16,5.16,0,0,0-.56-3.11A2.67,2.67,0,0,0,169.77,113.11Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,116.55l-.36-.54c.8-.54,2.6-1.17,3.63.23l-.52.39C164.64,115.37,162.89,116.5,162.82,116.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,115.35l-.54-.36c.17-.25,1.7-2.47,3.17-2.54s10,1.73,10.33,1.81l-.13.64c-2.46-.52-9.1-1.85-10.17-1.8S141.49,114.74,141.08,115.35Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,115.23s-2.53-5.73-5.06-4.92-1.32,8.62,1.17,10.15a2.78,2.78,0,0,0,3.94-.75Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.08,112.54a0,0,0,0,0,0,.07c1.73,1.13,2.37,3.07,2.71,5a1.54,1.54,0,0,0-2.17-.85c-.06,0,0,.11,0,.11a1.7,1.7,0,0,1,1.73,1,8.2,8.2,0,0,1,.59,1.66c.06.19.38.16.35,0v0C146.81,117,145.6,113.29,143.08,112.54Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Motorcycle--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.19,383.49c31.09,0,49.09,21.59,49.09,47S440.6,477,410.28,477c-33.55,0-49.57-26.68-49.57-46.74S376.73,383.49,408.19,383.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,383.49c29.55,0,46.67,21.59,46.67,47S434.22,477,405.4,477c-31.89,0-47.12-26.68-47.12-46.74S373.51,383.49,403.41,383.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.71,401.74c18,0,28.44,13.16,28.44,28.64s-9.66,28.33-27.23,28.33c-19.43,0-28.71-16.26-28.71-28.49S385.49,401.74,403.71,401.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,460c38.34,0,51.11-20.15,51.11-44.42s-17.82-44.92-52.64-44.92c22.73,0,35.89,20.63,35.89,44.92S205.09,460,182.93,460Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,370.69c22.73,0,35.89,20.64,35.89,44.91S205.1,460,182.93,460c-24.53,0-36.24-25.5-36.24-44.67S158.4,370.69,181.4,370.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.45,415.36c0,18.53-4.71,43,17.13,44.59l.77,0,.65,0,.93,0c22.16,0,34.36-20.15,34.36-44.42s-13.16-44.92-35.89-44.92l-1.22,0-.56,0c-.35,0-.71.05-1.06.08C158.84,372.89,163.45,397,163.45,415.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.78,388.14c12.63,0,19.95,12.58,19.95,27.37s-6.78,27.07-19.1,27.07c-13.64,0-20.15-15.54-20.15-27.22S167,388.14,179.78,388.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.9 277.34 345.67 277.34 337.29 265.04 351.62 265.04 357.9 277.34",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.29 265.04 342.2 272.24 345.67 277.34 357.9 277.34 354.59 270.86 351.61 265.04 337.29 265.04",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.29 265.04 342.2 272.24 354.59 270.86 351.61 265.04 337.29 265.04",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.62 369.13 375.71 371.87 364.79 361.75 378.75 358.55 387.62 369.13",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.79 361.75 371.18 367.67 375.7 371.87 387.63 369.13 382.95 363.56 378.75 358.55 364.79 361.75",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.79 361.75 371.18 367.67 382.95 363.56 378.75 358.55 364.79 361.75",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,405.44l3.42,7.57s92.47,7.07,101.25,5.76a130.82,130.82,0,0,0,18.41-28.47H292.61a40.52,40.52,0,0,1-18-4l-5.4-.9-9.73,4.86-10.63,15.14-29.55-.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46,390.3s23.68,14.56,69.84,9.62c1.71-2.92,3.45-6.13,5.14-9.62H292.61a40.52,40.52,0,0,1-18-4l-5.4-.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,389.49,443,395.57s-33.51-6.08-55-1.48-27.29,16.08-27.29,16.08H349.86S359.18,377.06,375,365s41.22-9.32,55.27-1.75S454.58,389.49,454.58,389.49Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,393.28a58.89,58.89,0,0,0-7.26-6.44,65.69,65.69,0,0,0-8.12-5.39,49.77,49.77,0,0,0-17.78-5.83c-12.22-1.5-25,2.06-34,11.45-5.06,5.32-8.66,11.84-12.08,18.44,0,.1.09.18.14.08a72.7,72.7,0,0,1,10.88-16,39,39,0,0,1,15.13-10.2c11.53-4.23,24.05-2.61,35.09,2.5a72.16,72.16,0,0,1,9.15,5c3,2,5.84,4.23,8.65,6.5A.12.12,0,0,0,441.79,393.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,326.52v-4.09L177.3,325.8V335S147,368.45,144,403.22l104.88,2.22,10.63-15.14,9.73-4.86,5.4.9V384l-4.14-4.87-.18-14.42a20.41,20.41,0,0,1-3.51-15.4C267.93,341.61,281.89,326.52,281.89,326.52Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.06,400.57c-1.09,2-17,4.87-47.16,5.68-27.15.73-47.43.13-49.05-1.62s2.43-32.7,20.81-49.46S208.11,336,225.27,346C240.36,354.77,251.62,377.06,239.06,400.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.18,371.27A38.5,38.5,0,0,0,233.48,352,42.91,42.91,0,0,0,214,340.81a49.48,49.48,0,0,0-25,.27,55.91,55.91,0,0,0-11.79,4.57,66.26,66.26,0,0,0-11.12,7.53c-.92.76-1.85,1.52-2.76,2.3-.08.06,0,.17.12.11a71.6,71.6,0,0,1,11.19-8.07,55.9,55.9,0,0,1,11.49-4.95,50.26,50.26,0,0,1,24.53-1.38,41.63,41.63,0,0,1,19.79,10,39.71,39.71,0,0,1,11.42,17.95c2.5,8.42,1.68,17.69-.81,26-.33,1.12-.68,2.22-1.06,3.32,0,.12.14.16.18.05C243.55,389.88,246.06,380.58,244.18,371.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46,390.3l9.73-4.86,5.4.9V384l-4.14-4.86-.18-14.41a20.36,20.36,0,0,1-3.51-15.4c1.17-7.71,15.13-22.8,15.13-22.8h-4.05s-22,11.35-27,20.72S244.33,378.59,259.46,390.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.49,409.44c-18.22,0-27.86-.56-32.75-2.5l2.27-5.71c5.72,2.27,23.63,2.23,52.45,1.9,21.29-.25,37-2.26,46.8-6l2.19,5.74c-10.6,4-26.6,6.12-48.92,6.38C185.06,409.37,177.76,409.44,171.49,409.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.64,270.72c-.18.41-24.33,4.86-24.33,4.86s-4-2.7-1.53-6.12L313,264.23A5.62,5.62,0,0,1,314.64,270.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.33,239.5v28.65s-15.47-1.35-19.59-1.49-22.43,2.23-22.43,2.23l-1.42-6.42S336,257.54,342,253.69s12.91-11.21,16.62-12.84A15,15,0,0,1,365.33,239.5Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.37,261.66a8.74,8.74,0,0,1,2.4,7.23S314.24,271,314.1,271a6.55,6.55,0,0,0-4-6.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.48,
    cy: 253.83,
    rx: 7.58,
    ry: 14.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.46,253.83c0,7,2.91,12.77,6.49,12.77s6.49-5.72,6.49-12.77-2.91-12.78-6.49-12.78S359.46,246.77,359.46,253.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,322.43s.19-17.47-.49-18.15-104.77-.32-107.88,0-2.84,20.67-2.57,21.62S279.19,322.66,281.89,322.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,304.46c-.31-.27-13.51-.33-14.23-.33s-.46,18.62,0,18.59,14.32-.11,14.77-.52S291.81,305.05,291.13,304.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.2,303.46a1.89,1.89,0,0,0-.67,1.12,9.57,9.57,0,0,0-.22,1.32c-.11.89-.14,1.79-.18,2.69,0,1.8,0,3.61,0,5.42s0,3.62.11,5.42a16.67,16.67,0,0,0,.31,2.65,4.32,4.32,0,0,0,.42,1.24,1.38,1.38,0,0,0,1,.77,1.41,1.41,0,0,1-1.22-.62,4.57,4.57,0,0,1-.67-1.25,13.48,13.48,0,0,1-.63-2.71,42.29,42.29,0,0,1-.33-5.5,45.81,45.81,0,0,1,.27-5.48,19.5,19.5,0,0,1,.48-2.73,9,9,0,0,1,.46-1.32A1.78,1.78,0,0,1,218.2,303.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.61,
    y: 241.93,
    width: 99.99,
    height: 62.16,
    transform: "translate(429.22 546.03) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.61,
    y: 241.93,
    width: 72.24,
    height: 62.16,
    transform: "translate(401.47 546.03) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.99 194.28 257.85 194.28 233.47 241.94 264.61 241.94 288.99 194.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.22 194.28 257.85 194.28 233.47 241.94 236.84 241.94 261.22 194.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.67,
    y: 241.93,
    width: 6.19,
    height: 62.19,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.16,
    y: 241.93,
    width: 6.19,
    height: 62.19,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.78,262.14v-7.07a.66.66,0,0,1,.66-.66h3.92a.67.67,0,0,1,0,1.33h-3.25v2.19h2.79a.68.68,0,0,1,.66.66.67.67,0,0,1-.66.68h-2.79v2.87a.67.67,0,0,1-.67.66A.66.66,0,0,1,181.78,262.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.42,255.45a4.41,4.41,0,0,1,0,6.07,3.92,3.92,0,0,1-2.87,1.28,4.06,4.06,0,0,1-2.94-1.28,4.49,4.49,0,0,1,0-6.07,4,4,0,0,1,2.94-1.28A3.89,3.89,0,0,1,195.42,255.45Zm-.16,3a3.11,3.11,0,0,0-.81-2.1,2.59,2.59,0,0,0-3.84,0,3.07,3.07,0,0,0-.82,2.1,3,3,0,0,0,.82,2.08,2.55,2.55,0,0,0,3.84,0A3,3,0,0,0,195.26,258.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5,255.45a4.41,4.41,0,0,1,0,6.07,3.92,3.92,0,0,1-2.87,1.28,4.06,4.06,0,0,1-2.94-1.28,4.49,4.49,0,0,1,0-6.07,4,4,0,0,1,2.94-1.28A3.89,3.89,0,0,1,205.5,255.45Zm-.16,3a3.11,3.11,0,0,0-.81-2.1,2.59,2.59,0,0,0-3.84,0,3.07,3.07,0,0,0-.82,2.1,3,3,0,0,0,.82,2.08,2.55,2.55,0,0,0,3.84,0A3,3,0,0,0,205.34,258.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72,262.14v-7.07a.65.65,0,0,1,.66-.66h1.41a4.2,4.2,0,0,1,0,8.39h-1.41A.66.66,0,0,1,208.72,262.14Zm1.33-.67h.74a2.87,2.87,0,0,0,0-5.73h-.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.64,268.09H195.3v4.5a.47.47,0,1,1-.93,0v-4.5H193a.48.48,0,0,1-.47-.47.47.47,0,0,1,.47-.47h3.6a.47.47,0,0,1,.46.47A.47.47,0,0,1,196.64,268.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.68,267.89a3.05,3.05,0,0,1,.85,2.13,3,3,0,0,1-.85,2.13,2.75,2.75,0,0,1-2,.91,2.86,2.86,0,0,1-2.07-.91,3,3,0,0,1-.83-2.13,3.08,3.08,0,0,1,.83-2.13,2.82,2.82,0,0,1,2.07-.9A2.7,2.7,0,0,1,202.68,267.89Zm-.11,2.13a2.15,2.15,0,0,0-.57-1.47,1.82,1.82,0,0,0-1.33-.6,1.85,1.85,0,0,0-1.37.6,2.18,2.18,0,0,0,0,2.94,1.85,1.85,0,0,0,1.37.6,1.82,1.82,0,0,0,1.33-.6A2.13,2.13,0,0,0,202.57,270Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8,283.77a10.13,10.13,0,0,1,9.66-8,7,7,0,0,1,4.8,1.75,1.22,1.22,0,0,1-.09,1.77,1.32,1.32,0,0,1-1.81.23,5,5,0,0,0-3.36-1.22,6.79,6.79,0,0,0-4.32,1.63,6.64,6.64,0,0,0-2.33,3.89,4.59,4.59,0,0,0,1,3.86,4.79,4.79,0,0,0,3.75,1.64,6.68,6.68,0,0,0,3.22-.88l.55-3.06h-3.2a1,1,0,0,1-1-1.26,1.55,1.55,0,0,1,1.49-1.27h4.44a1,1,0,0,1,1.06,1.27l-.88,5a2.24,2.24,0,0,1-.11.34l-.07.14,0,0a1.55,1.55,0,0,1-.49.53,9.72,9.72,0,0,1-5.4,1.75h0A6.66,6.66,0,0,1,181.8,283.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,289.47a7.06,7.06,0,0,1-1.22-5.65,10.06,10.06,0,0,1,3.22-5.66,8.88,8.88,0,0,1,5.86-2.39,6.2,6.2,0,0,1,5,2.39,7.21,7.21,0,0,1,1.19,5.66,9.81,9.81,0,0,1-3.2,5.65,8.88,8.88,0,0,1-5.86,2.39A6.11,6.11,0,0,1,201,289.47Zm1.33-5.65a5,5,0,0,0,.83,3.93,4.11,4.11,0,0,0,3.31,1.58,6,6,0,0,0,3.86-1.58,7,7,0,0,0,2.21-3.93,4.9,4.9,0,0,0-.83-3.91,4.09,4.09,0,0,0-3.31-1.59,5.87,5.87,0,0,0-3.86,1.59A7,7,0,0,0,202.36,283.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.78,
    y: 269.82,
    width: 7.09,
    height: 0.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.89,
    y: 269.82,
    width: 7.09,
    height: 0.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.92,277.34c2.52,3.69,12.61,53.87,14.59,56.39s5.77,2.7,5.77,2.7L395,353s-16.57,5.23-25.77,12.79C357.29,375.57,346.3,408,346.3,408c-1.8,1.26-24.14,10.45-30.27,10.81,0,0,28.49-31.28,30.81-74.57.9-16.78-9.41-40.39-10.09-52.09-.72-12.52,3.06-14.77,9.73-14.77Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.66,422.41l-4.46-4.22c25-26.46,34.22-68.15,33.49-79.53-.38-5.84-2.25-12.36-4.24-19.26-2.12-7.37-4.52-15.72-5.54-24.79-1-8.42,0-13.86,2.87-17.11s6.81-3.24,9.43-3.24H370v6.15H346.2c-2.29,0-3.85.08-4.84,1.19s-2.28,4-1.34,12.33c1,8.55,3.19,16.29,5.34,23.77,2.08,7.23,4.05,14.07,4.46,20.56C350.6,350.38,341,394.61,314.66,422.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.63,347.46c1.4,5.15,5.81,8.44,9.86,7.34s6.18-6.17,4.77-11.32-5.81-8.45-9.86-7.35S381.22,342.3,382.63,347.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.13,347.05c1.26,4.6,5.07,7.56,8.53,6.62s5.24-5.43,4-10-5.07-7.56-8.52-6.62S382.88,342.45,384.13,347.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.94,346.62c-1.11-5.18-2.31-10.35-3.35-15.55s-2-10.41-2.81-15.64c-.79-4.87-1.64-9.79-1.95-14.72-.31-5.15,0-10.35,2.5-15a.08.08,0,1,0-.14-.08c-2.57,3.75-3.41,8.25-3.55,12.72a86.4,86.4,0,0,0,1.3,14.71,315.87,315.87,0,0,0,6,31.69c1.45,5.91,3.32,11.72,5.32,17.46a.07.07,0,0,0,.14-.05Q366.61,354.42,364.94,346.62Z",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTawsel);
export default __webpack_public_path__ + "static/media/tawsel.b59f1ec3cfe2e559e06a2cfcda3f9d30.svg";
export { ForwardRef as ReactComponent };